import type { QuoteDispositionKind } from "@common/client"
import { z } from "zod"
import { DISPOSITIONS } from "@/routes/_layout/quoting_/quotes/-components/disposition-chip"

export const OUTCOMES = ["open", "won", "lost"] as const

export const outcomeSchema = z.enum(OUTCOMES)

export type Outcome = z.infer<typeof outcomeSchema>

export function outcomeOf(disposition: QuoteDispositionKind): Outcome {
  switch (disposition) {
    case "won":
      return "won"
    case "lost":
    case "cancelled":
    case "expired":
      return "lost"
    case "draft":
    case "review":
    case "customer_review":
    case "customer_response":
      return "open"
  }
}

export function outcomeLabel(outcome: Outcome): string {
  switch (outcome) {
    case "open":
      return "Open"
    case "won":
      return "Won"
    case "lost":
      return "Lost"
  }
}

export function withinOutcomes(
  statuses: QuoteDispositionKind[] | undefined,
  outcomes: Outcome[] | undefined,
): QuoteDispositionKind[] | undefined {
  if (!outcomes?.length) return statuses?.length ? statuses : undefined
  return (statuses?.length ? statuses : [...DISPOSITIONS]).filter(
    (disposition) => outcomes.includes(outcomeOf(disposition)),
  )
}
